export default function isPlaceEqual (place = {}, otherPlace = {}) {
    return place.place_id === otherPlace.place_id &&
    place.latitude === otherPlace.latitude &&
    place.longitude === otherPlace.longitude &&
    place.bounds === otherPlace.bounds
}
